import { Equals, IsNotEmpty, IsString } from 'class-validator';
import { UserSmsTokenVaultActions } from './token-vault-actions.enum';

export class UserActionTokenMobileNumberDto {
  @IsString()
  @IsNotEmpty()
  @Equals(UserSmsTokenVaultActions.USER_CHANGE_MOBILE)
  action!: UserSmsTokenVaultActions.USER_CHANGE_MOBILE;

  @IsString()
  @IsNotEmpty()
  token!: string;
}
